<template>
  <div>
    <div class="toolbar">
      <el-select v-model="supplierId" clearable filterable placeholder="供应商" style="width:200px">
        <el-option v-for="s in suppliers" :key="s.id" :label="s.name" :value="s.id" />
      </el-select>
      <el-input v-model="materialName" clearable placeholder="材料名称" style="width:180px" @keyup.enter.native="load" />
      <el-select
        v-model="categoryIds"
        multiple
        collapse-tags
        clearable
        filterable
        placeholder="材料分类（可多选）"
        style="width:240px"
      >
        <el-option
          v-for="c in categoryOptions"
          :key="c.id"
          :label="c.label"
          :value="c.id"
        />
      </el-select>
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        value-format="yyyy-MM-dd"
        start-placeholder="申请开始"
        end-placeholder="申请结束"
        style="width:260px"
      />
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
      <el-button icon="el-icon-download" :loading="exporting" :disabled="!list.length" @click="onExport">导出</el-button>
    </div>
    <el-table :data="pageList" border v-loading="loading" show-summary :summary-method="summaryMethod">
      <el-table-column prop="materialName" label="材料名称" min-width="180" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <el-button type="text" @click="openDetail(row)">{{ row.materialName || '-' }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="unit" label="单位" width="80" />
      <el-table-column prop="qty" label="销量" width="120" align="right">
        <template slot-scope="{ row }">{{ money(row.qty) }}</template>
      </el-table-column>
      <el-table-column prop="salesAmount" label="销售金额" width="140" align="right">
        <template slot-scope="{ row }">{{ money(row.salesAmount) }}</template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />

    <el-dialog
      :title="detailTitle"
      :visible.sync="detailVisible"
      width="900px"
      top="6vh"
      append-to-body
    >
      <el-table :data="detailList" border v-loading="detailLoading" max-height="520" show-summary :summary-method="detailSummary">
        <el-table-column prop="reqNo" label="申请单号" width="120" show-overflow-tooltip />
        <el-table-column prop="projectName" label="项目" min-width="140" show-overflow-tooltip />
        <el-table-column prop="supplierName" label="供应商" min-width="120" show-overflow-tooltip />
        <el-table-column prop="unit" label="单位" width="70" />
        <el-table-column prop="qty" label="销量" width="100" align="right">
          <template slot-scope="{ row }">{{ money(row.qty) }}</template>
        </el-table-column>
        <el-table-column prop="price" label="单价" width="100" align="right">
          <template slot-scope="{ row }">{{ money(row.price) }}</template>
        </el-table-column>
        <el-table-column prop="salesAmount" label="销售金额" width="120" align="right">
          <template slot-scope="{ row }">{{ money(row.salesAmount) }}</template>
        </el-table-column>
        <el-table-column prop="createdAt" label="申请时间" width="150">
          <template slot-scope="{ row }">{{ formatDateTime(row.createdAt) }}</template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { materialSalesReport, exportMaterialSalesReport, materialSalesDetail } from '../../api/report'
import { listSuppliers, treeMaterialCategories } from '../../api/supply'
import ListPagination from '../../components/ListPagination.vue'
import listPaging from '../../mixins/listPaging'
import { monthRange, money, num, downloadXlsx, formatDateTime } from './format'

export default {
  name: 'MaterialSalesReport',
  components: { ListPagination },
  mixins: [listPaging],
  data() {
    const range = monthRange()
    return {
      supplierId: null,
      materialName: '',
      categoryIds: [],
      categoryTree: [],
      dateRange: [range.startDate, range.endDate],
      suppliers: [],
      list: [],
      loading: false,
      exporting: false,
      detailVisible: false,
      detailLoading: false,
      detailTitle: '',
      detailList: []
    }
  },
  computed: {
    categoryOptions() {
      const out = []
      const walk = (nodes, depth) => {
        (nodes || []).forEach(n => {
          if (!n || n.id == null) return
          out.push({ id: n.id, label: '　'.repeat(depth) + (n.name || '') })
          walk(n.children, depth + 1)
        })
      }
      walk(this.categoryTree, 0)
      return out
    }
  },
  created() {
    this.loadMeta()
    this.load()
  },
  methods: {
    money,
    formatDateTime,
    queryParams() {
      const ids = (this.categoryIds || []).filter(id => id != null)
      return {
        supplierId: this.supplierId || undefined,
        materialName: this.materialName || undefined,
        categoryIds: ids.length ? ids.join(',') : undefined,
        startDate: this.dateRange && this.dateRange[0],
        endDate: this.dateRange && this.dateRange[1]
      }
    },
    async loadMeta() {
      const [supplierRes, categoryRes] = await Promise.all([
        listSuppliers({}),
        treeMaterialCategories()
      ])
      this.suppliers = supplierRes.data || []
      this.categoryTree = categoryRes.data || []
    },
    async load() {
      this.loading = true
      try {
        const res = await materialSalesReport(this.queryParams())
        this.list = (res.data && res.data.list) || []
        this.page = 1
      } finally {
        this.loading = false
      }
    },
    async onExport() {
      if (!this.list.length) {
        return this.$message.warning('暂无数据可导出')
      }
      this.exporting = true
      try {
        const res = await exportMaterialSalesReport(this.queryParams())
        downloadXlsx(res.data, '材料销量.xlsx')
      } catch (e) {
        this.$message.error('导出失败')
      } finally {
        this.exporting = false
      }
    },
    async openDetail(row) {
      if (!row.materialId) return
      this.detailTitle = `材料销量明细 - ${row.materialName || ''}`
      this.detailVisible = true
      this.detailLoading = true
      this.detailList = []
      try {
        const res = await materialSalesDetail({
          materialId: row.materialId,
          supplierId: this.supplierId || undefined,
          startDate: this.dateRange && this.dateRange[0],
          endDate: this.dateRange && this.dateRange[1]
        })
        this.detailList = (res.data && res.data.list) || []
      } catch (e) {
        this.$message.error('加载明细失败')
      } finally {
        this.detailLoading = false
      }
    },
    detailSummary({ columns }) {
      const data = this.detailList || []
      const amount = data.reduce((s, r) => s + num(r.salesAmount), 0)
      const qty = data.reduce((s, r) => s + num(r.qty), 0)
      return columns.map((col, i) => {
        if (i === 0) return '合计'
        if (col.property === 'salesAmount') return money(amount)
        if (col.property === 'qty') return money(qty)
        return ''
      })
    },
    summaryMethod({ columns }) {
      const data = this.list || []
      const amount = data.reduce((s, r) => s + num(r.salesAmount), 0)
      return columns.map((col, i) => {
        if (i === 0) return '合计'
        if (col.property === 'salesAmount') return money(amount)
        return ''
      })
    }
  }
}
</script>

<style scoped>
.toolbar { display:flex; gap:8px; margin-bottom:12px; flex-wrap:wrap; align-items:flex-start; }
.toolbar >>> .el-select__tags { flex-wrap:nowrap; overflow:hidden; }
.toolbar >>> .el-select__tags .el-tag { max-width:120px; }
.toolbar >>> .el-select__tags .el-tag .el-select__tags-text {
  display:inline-block;
  max-width:88px;
  overflow:hidden;
  text-overflow:ellipsis;
  vertical-align:bottom;
}
</style>
